import { FormRisk, User } from '@/types';

export type AuthState = {
  user: User;
  loaded: boolean;
};

export interface RiskState {
  data: FormRisk;
  backendResponse: FormRisk;
  isLoading: boolean;
  isLoadingSubmit: boolean;
  isValid: boolean;
  triedToSubmit: boolean;
  farePaid: boolean;
  showUnofficialPhoneAlert: boolean;
  auth: AuthState;
}

export const riskStateActions = [
  'risk_load_start',
  'risk_load_end',
  'risk_update_data',
  'risk_update_trucker',
  'risk_update_backend_response',
  'risk_store_error',
  'risk_update_field',
  'set_show_unofficial_phone_alert',
  'set_auth_state',
  'risk_set_is_valid',
  'risk_set_tried_to_submit',
  'set_fare_paid',
  'risk_form_reset',
  'set_submit_load',
] as const;

export type RiskStateAction = (typeof riskStateActions)[number];
